<template>
	<div class="max-w-xs m-4 overflow-hidden rounded shadow hover:shadow-md">
		<div @click="onAlbumClicked" class="cursor-pointer">
		<div class="mb-2">
			<img class="w-full h-full" style="object-fit: cover" :src="cover ? cover + '&w=600&h=400' : 'http://kemri-wellcome.org/wp-content/themes/kemri/img/img_placeholder.png'" alt="Album cover">
		</div>
		<div class="px-6 py-4">
			<div class="font-bold text-xl mb-1">{{this.title}}</div>
			<div class="font-light text-md text-grey-dark">24 Agosto 2018</div>
		</div>
		</div>
		<div class="px-6 py-6">
			<!-- <span class="inline-block bg-grey-lighter rounded-full px-3 py-1 text-sm font-semibold text-grey-darker mr-2">viewed</span> -->
			<!-- <span class="inline-block bg-grey-lighter rounded-full px-3 py-1 text-sm font-semibold text-grey-darker mr-2">paid</span> -->
			<span @click="deleteAlbum" class="cursor-pointer inline-block bg-grey-lighter rounded-full px-3 py-1 text-sm font-semibold text-grey-darker hover:shadow">Delete album</span>
		</div>
	</div>
</template>

<script>
import AlbumsRepository from "../repositories/AlbumsRepository";
export default {
  name: "Album",
  props: {
    id: {
      required: true,
      type: String
    },

    title: {
      required: true,
      type: String
    },

    cover: {
      required: false,
      type: String
    }
  },
  data() {
    return {
      isActive: false,
      albumPhotos: []
    };
  },

  methods: {
    onAlbumClicked() {
      this.$root.$emit("onAlbumSelected", this.id);
    },

    deleteAlbum() {
      AlbumsRepository.deleteAlbum(this.id);
    }
  },

  computed: {},

  mounted() {
    this.isActive = this.selected;
  }
};
</script>


// WEBPACK FOOTER //
// src/components/Album.vue